import PropTypes from "prop-types";

import InputSearchDropDown from "../../inputFields/dropdown/InputSearchDropDown";
import BaseComponent from "../../../../../lib/components/BaseComponent";

class FieldSelection extends BaseComponent {

  render() {
    let dropDownOptionsForFields = [{id: '-1', label: '[Keine Zuweisung]'}];
    this.props.fieldMapping.map((field, fieldMappingIndex) => {
      let fieldDescription = this.props.fieldMappingDescription[fieldMappingIndex];
      dropDownOptionsForFields.push({id: field, label: fieldDescription});
    });

    let records = this.props.records.map((record, index) => {
      return <div className='grid grid-cols-6 justify-center items-center gap-2 border-b-2 py-1 hover:border-cn-color-secondary'>
        <div className='col-span-2 lg:col-span-1'>
          {record.column}
        </div>
        <div className='col-span-2 lg:col-span-4'>
          {record.value}
        </div>
        <div className='col-span-2 lg:col-span-1'>
          <InputSearchDropDown size='small' onChange={(e, id, option) => {
            this.props.onMappingChanged(index, option.id);
          }} defaultValue={this.props.fieldMapping[record.fieldSelection]}>
            {dropDownOptionsForFields}
          </InputSearchDropDown>
        </div>
      </div>
    });

    return <div className='items-center flex-wrap py-5'>
      <div className='grid grid-cols-6 gap-2 border-b py-1'>
        <h3 className='col-span-2 lg:col-span-1'>Spalte</h3>
        <h3 className='col-span-2 lg:col-span-4'>Wert</h3>
        <h3 className='col-span-2 lg:col-span-1'>Feldauswahl</h3>
      </div>
      {records}
    </div>;
  }
}

FieldSelection.propTypes = {
  className: PropTypes.string,
  fieldMapping: PropTypes.array.isRequired,
  records: PropTypes.arrayOf(PropTypes.object),
  onMappingChanged: PropTypes.func.isRequired
}
export default FieldSelection;
